import { HttpErrorResponse, HttpEventType, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, tap, throwError } from 'rxjs';
import { AuthService } from '@/shared/services/auth.service';
import { AppRoutingPathsEnum } from '@/shared/config/app-routing-paths.enum';
import { SKIP_NOT_FOUND_REDIRECT, SKIP_RESOURCE_ERROR_REDIRECT } from '@/shared/config/http-context.config';
import { MainRoutingPathsEnum } from '@/shared/config/main-routing-paths.enum';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const skipResourceErrorRedirect = req.context.get(SKIP_RESOURCE_ERROR_REDIRECT);
  const skipNotFoundRedirect = req.context.get(SKIP_NOT_FOUND_REDIRECT);
  const isTariffRefreshRequest = req.url.includes('/auth/api/data/tariff');
  let tariffRefreshStarted = false;

  const refreshTariffIfNeeded = (): void => {
    if (!tariffRefreshStarted && !isTariffRefreshRequest && auth.isAuthenticated$()) {
      tariffRefreshStarted = true;
      auth.refreshTariff().subscribe();
    }
  };

  return next(req.clone({ withCredentials: true })).pipe(
    tap(event => {
      if (event.type === HttpEventType.Response) {
        refreshTariffIfNeeded();
      }
    }),
    catchError((error: HttpErrorResponse) => {
      refreshTariffIfNeeded();
      if (error.status === HttpStatusCode.Unauthorized && !auth.isLogoutInProgress()) {
        auth.clearSession();
        auth.redirectToSso();
      } else if (error.status === HttpStatusCode.Forbidden && !skipResourceErrorRedirect) {
        router.navigate([`${AppRoutingPathsEnum.Desktop}/${MainRoutingPathsEnum.Forbidden}`]).then();
      } else if (error.status === HttpStatusCode.NotFound && !skipResourceErrorRedirect && !skipNotFoundRedirect) {
        // replaceUrl: битый URL заменяется на /not-found, а не остаётся в истории —
        // иначе «Назад» на странице 404 вернул бы на страницу, которая снова упадёт в 404.
        router
          .navigate([`${AppRoutingPathsEnum.Desktop}/${MainRoutingPathsEnum.NotFound}`], { replaceUrl: true })
          .then();
      }
      return throwError(() => error);
    }),
  );
};
